import {State} from '../reducer';
import {settingsReducerKey} from './types';

export default {
   isFetching: (state: State) => state[settingsReducerKey].isFetching,
   getJobSettings: (state: State) => state[settingsReducerKey].jobSettings,
   getJobHistorySettings: (state: State) => state[settingsReducerKey].jobHistorySettings,
   getArchiveSettings: (state: State) => state[settingsReducerKey].archiveSettings,
   auditTrailSettings: (state: State) => state[settingsReducerKey].auditTrailSettings,
   supportEmailSettings: (state: State) => state[settingsReducerKey].supportEmailSettings,
   logginSettings: (state: State) => state[settingsReducerKey].logginSettings,
   sessionData: (state: State) => state[settingsReducerKey].sessionData,
   emailSettings: (state: State) => state[settingsReducerKey].emailSettings,
   ftpSettings: (state: State) => state[settingsReducerKey].ftpSettings,
   keySettings: (state: State) => state[settingsReducerKey].keySettings,
   pagingSettings: (state: State) => state[settingsReducerKey].pagingSettings,
   backupSettings: (state: State) => state[settingsReducerKey].backupSettings,
   adminRoles: (state: State) => state[settingsReducerKey].adminRoles,
};
